export const translations = {
  en: {
    nav: { home: 'Home', about: 'About', projects: 'Projects', contact: 'Contact' },
    hero: {
      kicker: 'SD // DEVOPS · DATA ENGINEER · DATA ANALYST · FULL STACK',
      buildFor: 'I build for',
      viewWork: 'View Work',
      getInTouch: 'Get In Touch',
      scroll: 'SCROLL',
      rotating: ['the cloud.', 'the pipeline.', 'the dashboard.', 'the platform.', 'production.'],
    },
    about: {
      kicker: 'ABOUT ME',
      heading: 'Building the systems behind the product.',
      bio:
        "I'm Santhosh Dayakar, a Co-Op student at Concordia University pursuing a Master's in Applied Computer Science. I work across the stack — provisioning cloud infrastructure, building data pipelines, analyzing data for insight, and shipping full-stack products end to end. I care about systems that are scalable, observable, and actually useful in production, not just in a demo.",
      resume: 'Download Resume',
      roles: ['DevOps Engineer', 'Data Engineer', 'Data Analyst', 'Full Stack Developer'],
    },
    education: { title: 'Education' },
    journey: { title: 'Journey', present: 'Present' },
    skills: {
      title: 'Skills',
      tabs: { All: 'All', Languages: 'Languages', Frameworks: 'Frameworks', Cloud: 'Cloud', ML: 'ML' },
    },
    certificates: { title: 'Certifications', issued: 'Issued', expires: 'Expires' },
    projects: { title: 'Projects', subtitle: 'Check out some of my featured work below.' },
    contact: {
      title: "Let's Connect",
      subtitle: 'Interested in working together or want to have a chat? Feel free to reach out!',
      namePlaceholder: 'Your Name',
      emailPlaceholder: 'Your Email',
      messagePlaceholder: 'Your Message',
      send: 'Send Message',
      errorFields: 'Please fill out all fields.',
      errorEmail: 'Please enter a valid email.',
      success: 'Message sent successfully! ✅',
      fail: 'Failed to send message. Please try again.',
    },
    footer: { rights: 'All rights reserved.' },
  },
  fr: {
    nav: { home: 'Accueil', about: 'À propos', projects: 'Projets', contact: 'Contact' },
    hero: {
      kicker: 'SD // DEVOPS · INGÉNIEUR DE DONNÉES · ANALYSTE DE DONNÉES · FULL STACK',
      buildFor: 'Je construis pour',
      viewWork: 'Voir mes projets',
      getInTouch: 'Me contacter',
      scroll: 'DÉFILER',
      rotating: ['le cloud.', 'le pipeline.', 'le tableau de bord.', 'la plateforme.', 'la production.'],
    },
    about: {
      kicker: 'À PROPOS DE MOI',
      heading: 'Je construis les systèmes derrière le produit.',
      bio:
        "Je m'appelle Santhosh Dayakar, étudiant coop à l'Université Concordia en Maîtrise d'informatique appliquée. Je travaille sur toute la chaîne — approvisionnement d'infrastructure cloud, création de pipelines de données, analyse de données et livraison de produits full-stack de bout en bout. Je tiens à des systèmes évolutifs, observables et réellement utiles en production, pas seulement en démo.",
      resume: 'Télécharger le CV',
      roles: ['Ingénieur DevOps', 'Ingénieur de données', 'Analyste de données', 'Développeur Full Stack'],
    },
    education: { title: 'Formation' },
    journey: { title: 'Parcours' },
    skills: {
      title: 'Compétences',
      tabs: { All: 'Toutes', Languages: 'Langages', Frameworks: 'Frameworks', Cloud: 'Cloud', ML: 'ML' },
    },
    certificates: { title: 'Certifications', issued: 'Obtenu', expires: 'Expire' },
    projects: { title: 'Projets', subtitle: 'Découvrez quelques-uns de mes projets phares ci-dessous.' },
    contact: {
      title: 'Discutons',
      subtitle: 'Intéressé à collaborer ou envie de discuter ? N\'hésitez pas à me contacter !',
      namePlaceholder: 'Votre nom',
      emailPlaceholder: 'Votre courriel',
      messagePlaceholder: 'Votre message',
      send: 'Envoyer le message',
      errorFields: 'Veuillez remplir tous les champs.',
      errorEmail: 'Veuillez entrer un courriel valide.',
      success: 'Message envoyé avec succès ! ✅',
      fail: "Échec de l'envoi du message. Veuillez réessayer.",
    },
    footer: { rights: 'Tous droits réservés.' },
  },
};
